import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faMapMarkerAlt, faBirthdayCake, faTv, faFilm } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Import JS
import 'bootstrap'

// Import SCSS
import './assets/css/styles.scss'

library.add(faMapMarkerAlt, faBirthdayCake, faTv, faFilm)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
